import TransactionsReport from './TransactionsReport.redux';

export default TransactionsReport;
